/**
 * 建立活動表單頁版面（Group / Square 共用）
 * 導覽列「建立活動」+ 返回 + 內容區，同一套版型
 */

import type { ReactNode } from 'react';
import {
  MobileNavbar,
  MobileNavbarBackButton,
} from '@/components/ui/mobile-navbar';

export interface CreateActivityFormLayoutProps {
  /** 返回按鈕點擊 */
  onBack: () => void;
  /** 標題（預設「建立活動」） */
  title?: string;
  /** 返回按鈕文字（預設「返回」） */
  backLabel?: string;
  /** 內容區 */
  children: ReactNode;
  /** 內容區額外 class（例如 space-y-4） */
  contentClassName?: string;
}

/**
 * 建立活動表單頁外殼：navbar + 返回 + 內容，供表單頁共用
 */
export function CreateActivityFormLayout({
  onBack,
  title = '建立活動',
  backLabel = '返回',
  children,
  contentClassName,
}: CreateActivityFormLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50 safe-area-container">
      <MobileNavbar
        title={title}
        left={<MobileNavbarBackButton label={backLabel} onClick={onBack} />}
      />
      <div className={contentClassName ? `p-4 ${contentClassName}` : 'p-4'}>
        {children}
      </div>
    </div>
  );
}
